<template>
  <v-container fluid ma-0 pa-0>
    <v-system-bar window dark app color="primary">
      <v-icon>mdi-shield-check</v-icon>
      <span v-if="suscripcion"
        >Información de la Licencia: Tipo: {{ suscripcion.tipo }} / Finaliza:
        {{ suscripcion.fechaFinSuscripcion | moment("DD-MM-YYYY") }}</span
      >
      <span v-else>Su periodo de prueba ha finalizado</span>
      <v-spacer></v-spacer>
      <!-- <v-icon>mdi-delete</v-icon>
      <v-icon>mdi-chevron-down</v-icon>
      <v-icon>mdi-close</v-icon> -->
    </v-system-bar>

    <!--   <v-navigation-drawer
      v-model="drawerRight"
      app
      clipped
      right
      disable-resize-watcher
      permanent
    >
      <v-list dense>
        <v-list-item @click.stop="right = !right">
          <v-list-item-action>
            <v-icon>mdi-close</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Open Temporary Drawer</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <p style="padding:0 15px 0 15px">
        <strong>RPA Maker</strong> es una aplicación que facilita el diseño,
        desarrollo y pruebas de robots de sofware para la automatización del
        navegador antes antes de ser incorporados en un producto final, con
        conectividad a servicios en la nube para despliegue, simulación y
        administración de la flota robótica para implementaciones a gran escala
        y distribuidas.
      </p>

      <p style="padding:0 15px 0 15px">
        Desarrollar, implementar y realizar pruebas de aplicaciones de robótica
        de sofware es complejo y toma mucho tiempo. Configurar un entorno de
        desarrollo puede tomar varios días, y crear un sistema de simulación
        realista para probar una aplicación de RPA en una arquitectura
        distribuida es costoso y podía llevar semanas debido a la
        infraestructura subyacente necesaria.
      </p>

      <p style="padding:0 15px 0 15px">
        Con <strong>RPA Maker</strong> se eliminan las cargas pesadas de cada
        paso del desarrollo de RPA y permite enfocarse en la creación de
        aplicaciones innovadoras.
      </p>
    </v-navigation-drawer> -->

    <v-app-bar app dark color="secondary" clipped-left>
      <!--  <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon> -->
      <!--        <v-avatar
          :color="color"
          :tile="tile"
          :size="avatarSize"
        >
          <img src="" alt="avatar">

        </v-avatar> -->

      <img src="@/assets/logo.svg" alt="avatar" width="185" />
      <v-divider class="mx-4" inset vertical></v-divider>
      <!--   <v-toolbar-title>Robotic Process Automation</v-toolbar-title> -->

      <span class="title font-weight-thin hidden-xs-only"
        >Inteligencia Empresarial para Compras Públicas</span
      >
      <v-spacer></v-spacer>
      <v-badge color="error" overlap class="mr-3">
        <template v-slot:badge>
          <span>0</span>
        </template>
        <v-icon>mdi-email</v-icon>
      </v-badge>
      <user></user>
    </v-app-bar>

    <!--     <v-navigation-drawer
      v-model="drawer"
      disable-resize-watcher
      permanent
      app
      clipped
      left
      style="margin-left:80px"
    >
      <v-toolbar elevation="1">
        <v-spacer></v-spacer>
        <hamburger></hamburger>
      </v-toolbar>
      <hamburguer></hamburguer>
  
    </v-navigation-drawer> -->

    <!-- <v-navigation-drawer v-model="left" fixed temporary></v-navigation-drawer> -->

    <!-- Sizes your content based upon application components -->
    <v-main>
      <!-- Provides the application the proper gutter -->
      <v-container fluid pa-0>
        <!-- If using vue-router -->

        <transition name="fade" mode="out-in">
          <router-view></router-view>
        </transition>
      </v-container>
    </v-main>

    <v-navigation-drawer
      app
      permanent
      mini-variant
      expand-on-hover
      color="background darken-1"
      clipped
      left
      width="455"
      style="padding-right:2px"
    >
      <vue-scroll :ops="ops">
        <v-list dense>
          <!--<v-list-item two-line>
            <v-list-item-avatar>
              <img src="https://randomuser.me/api/portraits/men/81.jpg" />
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>Luis Narea</v-list-item-title>
              <v-list-item-subtitle
                >luis.narea@inteldatos.com</v-list-item-subtitle
              >
            </v-list-item-content>
          </v-list-item> 

          <v-divider></v-divider>-->
          <template v-for="item in items">
            <v-layout v-if="item.heading" :key="item.heading" align-center>
              <v-flex xs6>
                <v-subheader v-if="item.heading">
                  {{ item.heading }}
                </v-subheader>
              </v-flex>
              <v-flex xs6 class="text-center">
                <a href="#!" class="body-2 black--text">EDIT</a>
              </v-flex>
            </v-layout>
            <v-list-group
              v-else-if="item.children"
              :key="item.text"
              v-model="item.model"
              :prepend-icon="item.model ? item.icon : item['icon-alt']"
              append-icon=""
            >
              <template v-slot:activator>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.text }}
                      <v-chip small v-if="item.appendChip" color="primary">
                        {{ item.appendChip }}
                      </v-chip>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <v-list-item
                v-for="(child, i) in item.children"
                v-bind:class="currentRouteClassObject(child.to)"
                :key="i"
                @click="goTo(child.to)"
              >
                <v-list-item-action v-if="child.icon">
                  <v-icon>{{ child.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ child.text }}
                    <v-chip small v-if="item.appendChip" color="primary">
                      {{ item.appendChip }}
                    </v-chip>
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
            <v-list-item
              v-else
              :key="item.text"
              @click="goTo(item.to)"
              v-bind:class="currentRouteClassObject(item.to)"
            >
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.text }}
                  <v-chip small v-if="item.appendChip" color="primary">
                    {{ item.appendChip }}
                  </v-chip>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </vue-scroll>
    </v-navigation-drawer>

    <!--   <v-footer app color="blue-grey" class="white--text">
      <span>Vuetify</span>
      <v-spacer></v-spacer>
      <span>&copy; 2019</span>
    </v-footer> -->
  </v-container>
</template>

<script>
import User from "@/components/User";
import { mapGetters } from "vuex";

export default {
  components: {
    User
  },
  data: () => ({
    currentRoute: null,
    drawer: null,
    drawerRight: null,
    right: false,
    left: false,
    currentItem: "",
    items: [
      /* {
        icon: "mdi-alpha-a-circle-outline",
        text: "Reporte de Ventas Públicas",
        to: "/dashboard/ventas-publicas"
      }, */
      {
        icon: "mdi-alpha-b-circle-outline",
        text: "Pac Consolidado",
        to: "/dashboard/pacs"
      },
      {
        icon: "mdi-alpha-c-circle-outline",
        text: "Procesos en Curso",
        to: "/dashboard/transito",
        appendChip: "Actualizado"
      },
      {
        icon: "mdi-alpha-d-circle-outline",
        text: "Procesos Ejecutados",
        to: "/dashboard/ejecutados",
        appendChip: "Actualizado"
      },
      {
        icon: "mdi-alpha-c-circle-outline",
        text: "Infimas Cuantías / Solicitudes de Proformas",
        to: "/dashboard/infima",
        appendChip: "Actualizado"
      },
      /* {
        icon: "mdi-alpha-a-circle-outline",
        text: "Reporte de Ventas",
        to: "/dashboard/pacs"
      }, */
      {
        icon: "mdi-alpha-e-circle-outline",
        text: "Entidades",
        to: "/dashboard/entidades"
      },
      {
        icon: "mdi-alpha-f-circle-outline",
        text: "Proveedores",
        to: "/dashboard/proveedores"
      },
      {
        icon: "mdi-alpha-g-circle-outline",
        text: "Tipos de Compra",
        to: "/dashboard/tipos"
      },
      {
        icon: "mdi-alpha-h-circle-outline",
        text: "Procedimientos",
        to: "/dashboard/procedimientos"
      },
      /*   {
        icon: "mdi-alpha-g-circle-outline",
        text: "Proveedores",
        to: "/dashboard/pacs"
      }, */
      {
        icon: "mdi-alpha-i-circle-outline",
        text: "CPC Nivel 5",
        to: "/dashboard/cpc5"
      },
      {
        icon: "mdi-alpha-j-circle-outline",
        text: "CPC Nivel 9",
        to: "/dashboard/cpc9"
      },
      {
        icon: "mdi-alpha-k-circle-outline",
        text: "Región",
        to: "/dashboard/region"
      },
      {
        icon: "mdi-alpha-l-circle-outline",
        text: "Provincias",
        to: "/dashboard/provincias"
      },
      {
        icon: "mdi-alpha-m-circle-outline",
        text: "Cantones",
        to: "/dashboard/cantones"
      },
      {
        icon: "mdi-alpha-n-circle-outline",
        text: "Régimen",
        to: "/dashboard/regimen"
      },
      {
        icon: "mdi-alpha-o-circle-outline",
        text: "Periodos",
        to: "/dashboard/periodos"
      },
      /* { icon: "mdi-help", text: "Preguntas Frecuentes", to: "/robots/links" },
      { icon: "mdi-settings", text: "Configuración", to: "/robots/links" },
      {
        icon: "mdi-comment-processing-outline",
        text: "Send feedback",
        to: "/robots/links"
      }, */
      { icon: "mdi-lifebuoy", text: "Ayuda", to: "/ayuda/esp" }
    ],
    ops: {
      bar: {
        background: "#cdcae0",
        keepShow: true,
        size: "7px",
        minSize: 0.1
      }
    }
  }),
  methods: {
    goTo: function(to) {
      this.$router.push(to);
    },
    currentRouteClassObject: function(to) {
      return {
        "current-view": to === this.currentRoute,
        "not-current-view": to != this.currentRoute
      };
    }
  },
  watch: {
    $route: {
      handler: function(to) {
        this.currentRoute = to.path;
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(["suscripcion"])
  }
};
</script>

<style lang="sass">

.current-view
  border-left: 4px solid var(--v-primary-base)
  margin-left: 3px
  .v-icon
    color: var(--v-primary-base)

.not-current-view
  .v-icon
    color: var(--v-secondary-base)
</style>
